<template>
  <div :style="buttonContainerStyles">
    <v-btn
      class="suus__post-form__button"
      block
      :color="inline ? 'white' : 'mediumGrey'"
      :disabled="disabled"
      @click="$emit('click')"
      :elevation="0"
    >
      <span :style="buttonLabelStyles">Speichern</span>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue"
import THEME from "constants/theme"

export default defineComponent({
  name: "PostFormButton",
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const buttonDisabledLabelColor = computed(() => {
      return props.inline ? "white" : THEME.colors.light.mediumGrey
    })

    const buttonLabelStyles = computed(() => {
      return {
        color: props.disabled
          ? buttonDisabledLabelColor.value
          : THEME.colors.light.primary,
        ...THEME.typography.button,
      }
    })

    const buttonContainerStyles = {
      backgroundColor: THEME.colors.light.lightGrey,
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
      border: `1px solid ${THEME.colors.light.mediumGrey}`,
      borderTop: "none",
    }

    return {
      buttonLabelStyles,
      buttonContainerStyles,
    }
  },
})
</script>

<style lang="sass" scoped>
.suus__post-form__button
  border-top-left-radius: 0
  border-top-right-radius: 0
</style>
